import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'
import React, { Suspense, lazy } from 'react'

// Carga los componentes de manera dinámica y especifica la importación de 'default'
const Header = lazy(
  async () =>
    await import('@/components/organisms/Header/Header').then((module) => ({
      default: module.default
    }))
)
const BannerHome = lazy(
  async () =>
    await import('@/components/templates/Home/BannerHome/BannerHome').then((module) => ({
      default: module.default
    }))
)
const FinancingStrategyTabs = lazy(
  async () =>
    await import('@/components/templates/Home/FinancingStrategyTabs/FinancingStrategyTabs').then((module) => ({
      default: module.default
    }))
)
const AtLumarPrestige = lazy(
  async () =>
    await import('@/components/templates/Home/AtLumarPrestige/AtLumarPrestige').then((module) => ({
      default: module.default
    }))
)
const WhyChooseLumarPrestige = lazy(
  async () =>
    await import('@/components/templates/Home/WhyChooseLumarPrestige/WhyChooseLumarPrestige').then((module) => ({
      default: module.default
    }))
)

const AccessToCapital = lazy(
  async () =>
    await import('@/components/templates/Home/AccessToCapital/AccessToCapital').then((module) => ({
      default: module.default
    }))
)
const CardsInspired = lazy(
  async () =>
    await import('@/components/templates/Home/CardsInspired/CardsInspired').then((module) => ({
      default: module.default
    }))
)

const FormContactUs = lazy(
  async () =>
    await import('@/components/templates/Home/FormContactUs/FormContactUs').then((module) => ({
      default: module.default
    }))
)

const Footer = lazy(
  async () =>
    await import('@/components/organisms/Footer/Footer').then((module) => ({
      default: module.default
    }))
)

export const Home: React.FC = () => {
  const buildDate = new Date().toISOString()

  return (
    <PageWrapper
      title='Lumar Prestige | We finance your growth with confidence, innovation, and solutions that evolve with you.'
      description='At Lumar Prestige, we drive your success with personalized and flexible financing options, designed to adapt to your company’s goals.'
      url='https://www.lumarprestige.io'
      keywords={[
        'Lumar Prestige',
        'Foreign trade operations',
        'Administrative processes',
        'Payments',
        'Optimization',
        'Simplification',
        'International trade',
        'Import/export',
        'Trade facilitation',
        'Business solutions',
        'Strategic ally',
        'Global business',
        'Customs clearance',
        'Compliance',
        'Trade finance',
        'Lumar Prestige foreign trade services',
        'Simplify administrative processes in international trade',
        'Optimize payments for foreign trade transactions',
        'Trade facilitation services for businesses',
        'Best practices for global business operations',
        'Customs clearance and compliance solutions',
        'Trade finance options for international trade'
      ]}
      language='en'
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className='min-h-screen flex flex-col overflow-hidden'>
          <Header />
          <main className='flex-grow'>
            <section id='home'>
              <BannerHome />
            </section>
            <section id='services'>
              <FinancingStrategyTabs />
            </section>
            <section id='aboutUs'>
              <AtLumarPrestige />
            </section>
            <section id='benefits'>
              <WhyChooseLumarPrestige />
            </section>
            <section id='AccessToCapital'>
              <AccessToCapital />
            </section>
            <section id='CardsInspired'>
              <CardsInspired />
            </section>
            <section id='formContactUs'>
              <FormContactUs />
            </section>
          </main>
          <Footer />
        </div>
      </Suspense>
    </PageWrapper>
  )
}
